export interface DepartmentResponsible {
  id?: string; // System.Guid
  departmentId: string; // System.Guid
  responsibleId: string; // System.Guid
  companyId?: string; // System.Guid
}

export interface Value {
  value: DepartmentResponsible[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

function parse(data?: Partial<DepartmentResponsible>): DepartmentResponsible {
  return {
    id: data?.id || undefined,
    departmentId: data?.departmentId || '',
    responsibleId: data?.responsibleId || '',
    companyId: data?.companyId || undefined,
  };
}

export default {
  parse,
};
